import * as React from "react";
const SvgPointToPoint = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 19L19 5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 19, cy: 5, r: 3, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 19, r: 3, fill: "currentColor" }));
export default SvgPointToPoint;
